/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AccountRouteImport } from './routes/account'
import { Route as R404RouteImport } from './routes/404'
import { Route as R403RouteImport } from './routes/403'
import { Route as TeacherRouteRouteImport } from './routes/teacher/route'
import { Route as PortalRouteRouteImport } from './routes/portal/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeacherIndexRouteImport } from './routes/teacher/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as PortalScheduleRouteImport } from './routes/portal/schedule'
import { Route as PortalProgressRouteImport } from './routes/portal/progress'
import { Route as PortalGradesRouteImport } from './routes/portal/grades'
import { Route as PortalAssignmentsRouteImport } from './routes/portal/assignments'
import { Route as AdminTeachersIndexRouteImport } from './routes/admin/teachers/index'
import { Route as AdminStudentsIndexRouteImport } from './routes/admin/students/index'
import { Route as AdminRoomsIndexRouteImport } from './routes/admin/rooms/index'
import { Route as AdminReportsIndexRouteImport } from './routes/admin/reports/index'
import { Route as AdminEnrollmentsIndexRouteImport } from './routes/admin/enrollments/index'
import { Route as AdminCoursesIndexRouteImport } from './routes/admin/courses/index'
import { Route as AdminClassesIndexRouteImport } from './routes/admin/classes/index'
import { Route as AdminBranchesIndexRouteImport } from './routes/admin/branches/index'
import { Route as AdminAuditLogIndexRouteImport } from './routes/admin/audit-log/index'
import { Route as TeacherClassesClassIdRouteImport } from './routes/teacher/classes/$classId'
import { Route as AdminStudentsStudentIdRouteImport } from './routes/admin/students/$studentId'
import { Route as AdminReportsReportIdRouteImport } from './routes/admin/reports/$reportId'
import { Route as AdminCoursesCourseIdRouteImport } from './routes/admin/courses/$courseId'
import { Route as AdminClassesClassIdRouteImport } from './routes/admin/classes/$classId'
import { Route as AdminBranchesBranchIdRouteImport } from './routes/admin/branches/$branchId'
import { Route as TeacherClassesClassIdRosterRouteImport } from './routes/teacher/classes/$classId.roster'
import { Route as TeacherClassesClassIdGradesRouteImport } from './routes/teacher/classes/$classId.grades'
import { Route as TeacherClassesClassIdAttendanceRouteImport } from './routes/teacher/classes/$classId.attendance'
import { Route as TeacherClassesClassIdAssignmentsRouteImport } from './routes/teacher/classes/$classId.assignments'
import { Route as TeacherClassesClassIdSessionsSessionIdRouteImport } from './routes/teacher/classes.$classId.sessions.$sessionId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherRouteRoute = TeacherRouteRouteImport.update({
  id: '/teacher',
  path: '/teacher',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRouteRoute = PortalRouteRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeacherIndexRoute = TeacherIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TeacherRouteRoute,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalScheduleRoute = PortalScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalProgressRoute = PortalProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalGradesRoute = PortalGradesRouteImport.update({
  id: '/grades',
  path: '/grades',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalAssignmentsRoute = PortalAssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => PortalRouteRoute,
} as any)
const AdminTeachersIndexRoute = AdminTeachersIndexRouteImport.update({
  id: '/teachers/',
  path: '/teachers/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminStudentsIndexRoute = AdminStudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRoomsIndexRoute = AdminRoomsIndexRouteImport.update({
  id: '/rooms/',
  path: '/rooms/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReportsIndexRoute = AdminReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminEnrollmentsIndexRoute = AdminEnrollmentsIndexRouteImport.update({
  id: '/enrollments/',
  path: '/enrollments/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCoursesIndexRoute = AdminCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminClassesIndexRoute = AdminClassesIndexRouteImport.update({
  id: '/classes/',
  path: '/classes/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBranchesIndexRoute = AdminBranchesIndexRouteImport.update({
  id: '/branches/',
  path: '/branches/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditLogIndexRoute = AdminAuditLogIndexRouteImport.update({
  id: '/audit-log/',
  path: '/audit-log/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TeacherClassesClassIdRoute = TeacherClassesClassIdRouteImport.update({
  id: '/classes/$classId',
  path: '/classes/$classId',
  getParentRoute: () => TeacherRouteRoute,
} as any)
const AdminStudentsStudentIdRoute = AdminStudentsStudentIdRouteImport.update({
  id: '/students/$studentId',
  path: '/students/$studentId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminReportsReportIdRoute = AdminReportsReportIdRouteImport.update({
  id: '/reports/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCoursesCourseIdRoute = AdminCoursesCourseIdRouteImport.update({
  id: '/courses/$courseId',
  path: '/courses/$courseId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminClassesClassIdRoute = AdminClassesClassIdRouteImport.update({
  id: '/classes/$classId',
  path: '/classes/$classId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminBranchesBranchIdRoute = AdminBranchesBranchIdRouteImport.update({
  id: '/branches/$branchId',
  path: '/branches/$branchId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const TeacherClassesClassIdRosterRoute =
  TeacherClassesClassIdRosterRouteImport.update({
    id: '/roster',
    path: '/roster',
    getParentRoute: () => TeacherClassesClassIdRoute,
  } as any)
const TeacherClassesClassIdGradesRoute =
  TeacherClassesClassIdGradesRouteImport.update({
    id: '/grades',
    path: '/grades',
    getParentRoute: () => TeacherClassesClassIdRoute,
  } as any)
const TeacherClassesClassIdAttendanceRoute =
  TeacherClassesClassIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => TeacherClassesClassIdRoute,
  } as any)
const TeacherClassesClassIdAssignmentsRoute =
  TeacherClassesClassIdAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => TeacherClassesClassIdRoute,
  } as any)
const TeacherClassesClassIdSessionsSessionIdRoute =
  TeacherClassesClassIdSessionsSessionIdRouteImport.update({
    id: '/sessions/$sessionId',
    path: '/sessions/$sessionId',
    getParentRoute: () => TeacherClassesClassIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/portal': typeof PortalRouteRouteWithChildren
  '/teacher': typeof TeacherRouteRouteWithChildren
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/account': typeof AccountRoute
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/portal/assignments': typeof PortalAssignmentsRoute
  '/portal/grades': typeof PortalGradesRoute
  '/portal/progress': typeof PortalProgressRoute
  '/portal/schedule': typeof PortalScheduleRoute
  '/r/$token': typeof RTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/teacher/': typeof TeacherIndexRoute
  '/admin/branches/$branchId': typeof AdminBranchesBranchIdRoute
  '/admin/classes/$classId': typeof AdminClassesClassIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/reports/$reportId': typeof AdminReportsReportIdRoute
  '/admin/students/$studentId': typeof AdminStudentsStudentIdRoute
  '/teacher/classes/$classId': typeof TeacherClassesClassIdRouteWithChildren
  '/admin/audit-log/': typeof AdminAuditLogIndexRoute
  '/admin/branches/': typeof AdminBranchesIndexRoute
  '/admin/classes/': typeof AdminClassesIndexRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/enrollments/': typeof AdminEnrollmentsIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/admin/rooms/': typeof AdminRoomsIndexRoute
  '/admin/students/': typeof AdminStudentsIndexRoute
  '/admin/teachers/': typeof AdminTeachersIndexRoute
  '/teacher/classes/$classId/assignments': typeof TeacherClassesClassIdAssignmentsRoute
  '/teacher/classes/$classId/attendance': typeof TeacherClassesClassIdAttendanceRoute
  '/teacher/classes/$classId/grades': typeof TeacherClassesClassIdGradesRoute
  '/teacher/classes/$classId/roster': typeof TeacherClassesClassIdRosterRoute
  '/teacher/classes/$classId/sessions/$sessionId': typeof TeacherClassesClassIdSessionsSessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/account': typeof AccountRoute
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/portal/assignments': typeof PortalAssignmentsRoute
  '/portal/grades': typeof PortalGradesRoute
  '/portal/progress': typeof PortalProgressRoute
  '/portal/schedule': typeof PortalScheduleRoute
  '/r/$token': typeof RTokenRoute
  '/admin': typeof AdminIndexRoute
  '/portal': typeof PortalIndexRoute
  '/teacher': typeof TeacherIndexRoute
  '/admin/branches/$branchId': typeof AdminBranchesBranchIdRoute
  '/admin/classes/$classId': typeof AdminClassesClassIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/reports/$reportId': typeof AdminReportsReportIdRoute
  '/admin/students/$studentId': typeof AdminStudentsStudentIdRoute
  '/teacher/classes/$classId': typeof TeacherClassesClassIdRouteWithChildren
  '/admin/audit-log': typeof AdminAuditLogIndexRoute
  '/admin/branches': typeof AdminBranchesIndexRoute
  '/admin/classes': typeof AdminClassesIndexRoute
  '/admin/courses': typeof AdminCoursesIndexRoute
  '/admin/enrollments': typeof AdminEnrollmentsIndexRoute
  '/admin/reports': typeof AdminReportsIndexRoute
  '/admin/rooms': typeof AdminRoomsIndexRoute
  '/admin/students': typeof AdminStudentsIndexRoute
  '/admin/teachers': typeof AdminTeachersIndexRoute
  '/teacher/classes/$classId/assignments': typeof TeacherClassesClassIdAssignmentsRoute
  '/teacher/classes/$classId/attendance': typeof TeacherClassesClassIdAttendanceRoute
  '/teacher/classes/$classId/grades': typeof TeacherClassesClassIdGradesRoute
  '/teacher/classes/$classId/roster': typeof TeacherClassesClassIdRosterRoute
  '/teacher/classes/$classId/sessions/$sessionId': typeof TeacherClassesClassIdSessionsSessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/portal': typeof PortalRouteRouteWithChildren
  '/teacher': typeof TeacherRouteRouteWithChildren
  '/403': typeof R403Route
  '/404': typeof R404Route
  '/account': typeof AccountRoute
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/portal/assignments': typeof PortalAssignmentsRoute
  '/portal/grades': typeof PortalGradesRoute
  '/portal/progress': typeof PortalProgressRoute
  '/portal/schedule': typeof PortalScheduleRoute
  '/r/$token': typeof RTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/teacher/': typeof TeacherIndexRoute
  '/admin/branches/$branchId': typeof AdminBranchesBranchIdRoute
  '/admin/classes/$classId': typeof AdminClassesClassIdRoute
  '/admin/courses/$courseId': typeof AdminCoursesCourseIdRoute
  '/admin/reports/$reportId': typeof AdminReportsReportIdRoute
  '/admin/students/$studentId': typeof AdminStudentsStudentIdRoute
  '/teacher/classes/$classId': typeof TeacherClassesClassIdRouteWithChildren
  '/admin/audit-log/': typeof AdminAuditLogIndexRoute
  '/admin/branches/': typeof AdminBranchesIndexRoute
  '/admin/classes/': typeof AdminClassesIndexRoute
  '/admin/courses/': typeof AdminCoursesIndexRoute
  '/admin/enrollments/': typeof AdminEnrollmentsIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/admin/rooms/': typeof AdminRoomsIndexRoute
  '/admin/students/': typeof AdminStudentsIndexRoute
  '/admin/teachers/': typeof AdminTeachersIndexRoute
  '/teacher/classes/$classId/assignments': typeof TeacherClassesClassIdAssignmentsRoute
  '/teacher/classes/$classId/attendance': typeof TeacherClassesClassIdAttendanceRoute
  '/teacher/classes/$classId/grades': typeof TeacherClassesClassIdGradesRoute
  '/teacher/classes/$classId/roster': typeof TeacherClassesClassIdRosterRoute
  '/teacher/classes/$classId/sessions/$sessionId': typeof TeacherClassesClassIdSessionsSessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/portal'
    | '/teacher'
    | '/403'
    | '/404'
    | '/account'
    | '/login'
    | '/verify-email'
    | '/portal/assignments'
    | '/portal/grades'
    | '/portal/progress'
    | '/portal/schedule'
    | '/r/$token'
    | '/admin/'
    | '/portal/'
    | '/teacher/'
    | '/admin/branches/$branchId'
    | '/admin/classes/$classId'
    | '/admin/courses/$courseId'
    | '/admin/reports/$reportId'
    | '/admin/students/$studentId'
    | '/teacher/classes/$classId'
    | '/admin/audit-log/'
    | '/admin/branches/'
    | '/admin/classes/'
    | '/admin/courses/'
    | '/admin/enrollments/'
    | '/admin/reports/'
    | '/admin/rooms/'
    | '/admin/students/'
    | '/admin/teachers/'
    | '/teacher/classes/$classId/assignments'
    | '/teacher/classes/$classId/attendance'
    | '/teacher/classes/$classId/grades'
    | '/teacher/classes/$classId/roster'
    | '/teacher/classes/$classId/sessions/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/404'
    | '/account'
    | '/login'
    | '/verify-email'
    | '/portal/assignments'
    | '/portal/grades'
    | '/portal/progress'
    | '/portal/schedule'
    | '/r/$token'
    | '/admin'
    | '/portal'
    | '/teacher'
    | '/admin/branches/$branchId'
    | '/admin/classes/$classId'
    | '/admin/courses/$courseId'
    | '/admin/reports/$reportId'
    | '/admin/students/$studentId'
    | '/teacher/classes/$classId'
    | '/admin/audit-log'
    | '/admin/branches'
    | '/admin/classes'
    | '/admin/courses'
    | '/admin/enrollments'
    | '/admin/reports'
    | '/admin/rooms'
    | '/admin/students'
    | '/admin/teachers'
    | '/teacher/classes/$classId/assignments'
    | '/teacher/classes/$classId/attendance'
    | '/teacher/classes/$classId/grades'
    | '/teacher/classes/$classId/roster'
    | '/teacher/classes/$classId/sessions/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/portal'
    | '/teacher'
    | '/403'
    | '/404'
    | '/account'
    | '/login'
    | '/verify-email'
    | '/portal/assignments'
    | '/portal/grades'
    | '/portal/progress'
    | '/portal/schedule'
    | '/r/$token'
    | '/admin/'
    | '/portal/'
    | '/teacher/'
    | '/admin/branches/$branchId'
    | '/admin/classes/$classId'
    | '/admin/courses/$courseId'
    | '/admin/reports/$reportId'
    | '/admin/students/$studentId'
    | '/teacher/classes/$classId'
    | '/admin/audit-log/'
    | '/admin/branches/'
    | '/admin/classes/'
    | '/admin/courses/'
    | '/admin/enrollments/'
    | '/admin/reports/'
    | '/admin/rooms/'
    | '/admin/students/'
    | '/admin/teachers/'
    | '/teacher/classes/$classId/assignments'
    | '/teacher/classes/$classId/attendance'
    | '/teacher/classes/$classId/grades'
    | '/teacher/classes/$classId/roster'
    | '/teacher/classes/$classId/sessions/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  PortalRouteRoute: typeof PortalRouteRouteWithChildren
  TeacherRouteRoute: typeof TeacherRouteRouteWithChildren
  R403Route: typeof R403Route
  R404Route: typeof R404Route
  AccountRoute: typeof AccountRoute
  LoginRoute: typeof LoginRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  RTokenRoute: typeof RTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher': {
      id: '/teacher'
      path: '/teacher'
      fullPath: '/teacher'
      preLoaderRoute: typeof TeacherRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teacher/': {
      id: '/teacher/'
      path: '/'
      fullPath: '/teacher/'
      preLoaderRoute: typeof TeacherIndexRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/schedule': {
      id: '/portal/schedule'
      path: '/schedule'
      fullPath: '/portal/schedule'
      preLoaderRoute: typeof PortalScheduleRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/progress': {
      id: '/portal/progress'
      path: '/progress'
      fullPath: '/portal/progress'
      preLoaderRoute: typeof PortalProgressRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/grades': {
      id: '/portal/grades'
      path: '/grades'
      fullPath: '/portal/grades'
      preLoaderRoute: typeof PortalGradesRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/assignments': {
      id: '/portal/assignments'
      path: '/assignments'
      fullPath: '/portal/assignments'
      preLoaderRoute: typeof PortalAssignmentsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/admin/teachers/': {
      id: '/admin/teachers/'
      path: '/teachers'
      fullPath: '/admin/teachers/'
      preLoaderRoute: typeof AdminTeachersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/students/': {
      id: '/admin/students/'
      path: '/students'
      fullPath: '/admin/students/'
      preLoaderRoute: typeof AdminStudentsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/rooms/': {
      id: '/admin/rooms/'
      path: '/rooms'
      fullPath: '/admin/rooms/'
      preLoaderRoute: typeof AdminRoomsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/reports/': {
      id: '/admin/reports/'
      path: '/reports'
      fullPath: '/admin/reports/'
      preLoaderRoute: typeof AdminReportsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/enrollments/': {
      id: '/admin/enrollments/'
      path: '/enrollments'
      fullPath: '/admin/enrollments/'
      preLoaderRoute: typeof AdminEnrollmentsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/': {
      id: '/admin/courses/'
      path: '/courses'
      fullPath: '/admin/courses/'
      preLoaderRoute: typeof AdminCoursesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/classes/': {
      id: '/admin/classes/'
      path: '/classes'
      fullPath: '/admin/classes/'
      preLoaderRoute: typeof AdminClassesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branches/': {
      id: '/admin/branches/'
      path: '/branches'
      fullPath: '/admin/branches/'
      preLoaderRoute: typeof AdminBranchesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit-log/': {
      id: '/admin/audit-log/'
      path: '/audit-log'
      fullPath: '/admin/audit-log/'
      preLoaderRoute: typeof AdminAuditLogIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/classes/$classId': {
      id: '/teacher/classes/$classId'
      path: '/classes/$classId'
      fullPath: '/teacher/classes/$classId'
      preLoaderRoute: typeof TeacherClassesClassIdRouteImport
      parentRoute: typeof TeacherRouteRoute
    }
    '/admin/students/$studentId': {
      id: '/admin/students/$studentId'
      path: '/students/$studentId'
      fullPath: '/admin/students/$studentId'
      preLoaderRoute: typeof AdminStudentsStudentIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/reports/$reportId': {
      id: '/admin/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/admin/reports/$reportId'
      preLoaderRoute: typeof AdminReportsReportIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/courses/$courseId': {
      id: '/admin/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/admin/courses/$courseId'
      preLoaderRoute: typeof AdminCoursesCourseIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/classes/$classId': {
      id: '/admin/classes/$classId'
      path: '/classes/$classId'
      fullPath: '/admin/classes/$classId'
      preLoaderRoute: typeof AdminClassesClassIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/branches/$branchId': {
      id: '/admin/branches/$branchId'
      path: '/branches/$branchId'
      fullPath: '/admin/branches/$branchId'
      preLoaderRoute: typeof AdminBranchesBranchIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/teacher/classes/$classId/roster': {
      id: '/teacher/classes/$classId/roster'
      path: '/roster'
      fullPath: '/teacher/classes/$classId/roster'
      preLoaderRoute: typeof TeacherClassesClassIdRosterRouteImport
      parentRoute: typeof TeacherClassesClassIdRoute
    }
    '/teacher/classes/$classId/grades': {
      id: '/teacher/classes/$classId/grades'
      path: '/grades'
      fullPath: '/teacher/classes/$classId/grades'
      preLoaderRoute: typeof TeacherClassesClassIdGradesRouteImport
      parentRoute: typeof TeacherClassesClassIdRoute
    }
    '/teacher/classes/$classId/attendance': {
      id: '/teacher/classes/$classId/attendance'
      path: '/attendance'
      fullPath: '/teacher/classes/$classId/attendance'
      preLoaderRoute: typeof TeacherClassesClassIdAttendanceRouteImport
      parentRoute: typeof TeacherClassesClassIdRoute
    }
    '/teacher/classes/$classId/assignments': {
      id: '/teacher/classes/$classId/assignments'
      path: '/assignments'
      fullPath: '/teacher/classes/$classId/assignments'
      preLoaderRoute: typeof TeacherClassesClassIdAssignmentsRouteImport
      parentRoute: typeof TeacherClassesClassIdRoute
    }
    '/teacher/classes/$classId/sessions/$sessionId': {
      id: '/teacher/classes/$classId/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/teacher/classes/$classId/sessions/$sessionId'
      preLoaderRoute: typeof TeacherClassesClassIdSessionsSessionIdRouteImport
      parentRoute: typeof TeacherClassesClassIdRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminBranchesBranchIdRoute: typeof AdminBranchesBranchIdRoute
  AdminClassesClassIdRoute: typeof AdminClassesClassIdRoute
  AdminCoursesCourseIdRoute: typeof AdminCoursesCourseIdRoute
  AdminReportsReportIdRoute: typeof AdminReportsReportIdRoute
  AdminStudentsStudentIdRoute: typeof AdminStudentsStudentIdRoute
  AdminAuditLogIndexRoute: typeof AdminAuditLogIndexRoute
  AdminBranchesIndexRoute: typeof AdminBranchesIndexRoute
  AdminClassesIndexRoute: typeof AdminClassesIndexRoute
  AdminCoursesIndexRoute: typeof AdminCoursesIndexRoute
  AdminEnrollmentsIndexRoute: typeof AdminEnrollmentsIndexRoute
  AdminReportsIndexRoute: typeof AdminReportsIndexRoute
  AdminRoomsIndexRoute: typeof AdminRoomsIndexRoute
  AdminStudentsIndexRoute: typeof AdminStudentsIndexRoute
  AdminTeachersIndexRoute: typeof AdminTeachersIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminBranchesBranchIdRoute: AdminBranchesBranchIdRoute,
  AdminClassesClassIdRoute: AdminClassesClassIdRoute,
  AdminCoursesCourseIdRoute: AdminCoursesCourseIdRoute,
  AdminReportsReportIdRoute: AdminReportsReportIdRoute,
  AdminStudentsStudentIdRoute: AdminStudentsStudentIdRoute,
  AdminAuditLogIndexRoute: AdminAuditLogIndexRoute,
  AdminBranchesIndexRoute: AdminBranchesIndexRoute,
  AdminClassesIndexRoute: AdminClassesIndexRoute,
  AdminCoursesIndexRoute: AdminCoursesIndexRoute,
  AdminEnrollmentsIndexRoute: AdminEnrollmentsIndexRoute,
  AdminReportsIndexRoute: AdminReportsIndexRoute,
  AdminRoomsIndexRoute: AdminRoomsIndexRoute,
  AdminStudentsIndexRoute: AdminStudentsIndexRoute,
  AdminTeachersIndexRoute: AdminTeachersIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface PortalRouteRouteChildren {
  PortalAssignmentsRoute: typeof PortalAssignmentsRoute
  PortalGradesRoute: typeof PortalGradesRoute
  PortalProgressRoute: typeof PortalProgressRoute
  PortalScheduleRoute: typeof PortalScheduleRoute
  PortalIndexRoute: typeof PortalIndexRoute
}

const PortalRouteRouteChildren: PortalRouteRouteChildren = {
  PortalAssignmentsRoute: PortalAssignmentsRoute,
  PortalGradesRoute: PortalGradesRoute,
  PortalProgressRoute: PortalProgressRoute,
  PortalScheduleRoute: PortalScheduleRoute,
  PortalIndexRoute: PortalIndexRoute,
}

const PortalRouteRouteWithChildren = PortalRouteRoute._addFileChildren(
  PortalRouteRouteChildren,
)

interface TeacherClassesClassIdRouteChildren {
  TeacherClassesClassIdAssignmentsRoute: typeof TeacherClassesClassIdAssignmentsRoute
  TeacherClassesClassIdAttendanceRoute: typeof TeacherClassesClassIdAttendanceRoute
  TeacherClassesClassIdGradesRoute: typeof TeacherClassesClassIdGradesRoute
  TeacherClassesClassIdRosterRoute: typeof TeacherClassesClassIdRosterRoute
  TeacherClassesClassIdSessionsSessionIdRoute: typeof TeacherClassesClassIdSessionsSessionIdRoute
}

const TeacherClassesClassIdRouteChildren: TeacherClassesClassIdRouteChildren = {
  TeacherClassesClassIdAssignmentsRoute: TeacherClassesClassIdAssignmentsRoute,
  TeacherClassesClassIdAttendanceRoute: TeacherClassesClassIdAttendanceRoute,
  TeacherClassesClassIdGradesRoute: TeacherClassesClassIdGradesRoute,
  TeacherClassesClassIdRosterRoute: TeacherClassesClassIdRosterRoute,
  TeacherClassesClassIdSessionsSessionIdRoute:
    TeacherClassesClassIdSessionsSessionIdRoute,
}

const TeacherClassesClassIdRouteWithChildren =
  TeacherClassesClassIdRoute._addFileChildren(
    TeacherClassesClassIdRouteChildren,
  )

interface TeacherRouteRouteChildren {
  TeacherIndexRoute: typeof TeacherIndexRoute
  TeacherClassesClassIdRoute: typeof TeacherClassesClassIdRouteWithChildren
}

const TeacherRouteRouteChildren: TeacherRouteRouteChildren = {
  TeacherIndexRoute: TeacherIndexRoute,
  TeacherClassesClassIdRoute: TeacherClassesClassIdRouteWithChildren,
}

const TeacherRouteRouteWithChildren = TeacherRouteRoute._addFileChildren(
  TeacherRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  PortalRouteRoute: PortalRouteRouteWithChildren,
  TeacherRouteRoute: TeacherRouteRouteWithChildren,
  R403Route: R403Route,
  R404Route: R404Route,
  AccountRoute: AccountRoute,
  LoginRoute: LoginRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  RTokenRoute: RTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
